import { SproToasterService } from "../sproLib/spro/services/spro-toaster/spro-toaster.service";
import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { Observable } from "rxjs/Observable";

@Injectable()
export class AuthAdminService implements CanActivate {
  /** Session en cours */
  public h_currentUser: any;

  constructor(public router: Router, public s_toaster: SproToasterService) {}

  /**
   * Test si l'accès aux pages admin est autorisé
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    this.h_currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (this.h_currentUser.isadmin === "true") return true;

    this.router.navigate(["pages/commun/pageAccueil"]);
    this.s_toaster.proc_toastTradError("Messages.interdit");
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/auth-admin.service.ts